import React from 'react';
import { translations } from '../../translations';

interface TrialBannerProps {
  isDarkMode: boolean;
  language: string;
}

export function TrialBanner({ isDarkMode, language }: TrialBannerProps) {
  const t = translations[language as keyof typeof translations];

  return (
    <div className={`rounded-lg p-4 mb-6 ${
      isDarkMode ? 'bg-[#1c1c1c]' : 'bg-white'
    } border ${
      isDarkMode ? 'border-[#2b2b2b]' : 'border-[#e5e7eb]'
    }`}>
      <div className="flex items-center gap-3">
        <div>
          <h3 className={`font-medium ${
            isDarkMode ? 'text-gray-200' : 'text-gray-900'
          }`}>
            {t.free_trial_banner_title}
          </h3>
          <p className={`text-sm ${
            isDarkMode ? 'text-gray-400' : 'text-gray-600'
          }`}>
            {t.free_trial_banner_description}
          </p>
        </div>
      </div>
    </div>
  );
}